/**
 * Composant pour afficher un résultat (succès ou erreur)
 * @module admin/components/AdminResult
 */

import React from 'react';
import PropTypes from 'prop-types';

/**
 * Composant d'affichage de résultat
 * @param {Object} props
 * @param {boolean} props.isSuccess - Si true, affiche un résultat de succès
 * @param {string} props.title - Titre du résultat
 * @param {string|React.ReactNode} props.message - Message à afficher
 * @param {React.ReactNode} [props.children] - Contenu additionnel (ex: pre avec JSON)
 * @param {string} [props.className] - Classes CSS supplémentaires
 * @returns {JSX.Element}
 */
const AdminResult = ({ isSuccess, title, message, children, className = '' }) => {
  const resultClass = isSuccess ? 'admin-result-success' : 'admin-result-error';

  return (
    <div className={`admin-result ${resultClass} ${className}`}>
      <h3>{title}</h3>
      {message && <p>{message}</p>}
      {children}
    </div>
  );
};

AdminResult.propTypes = {
  isSuccess: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.node,
  className: PropTypes.string,
};

export default AdminResult;
